var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"!click":function($event){return _vm.$emit('click',$event)}}},[_c('el-button',{attrs:{"disabled":_vm.buttonText!=='发送验证码'},on:{"click":_vm.send}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }